import React from 'react';
import { Box, Typography, Divider, Link } from '@mui/material';
import EastOutlinedIcon from '@mui/icons-material/EastOutlined';
import { ATHLETIKO_URL } from '@/config';
import { NoEvents } from '@/static/icons';
import styles from './styles';

type LiveBlogEvent = {
  author: string;
  title: string;
  status: string;
  slug: string;
};

type LiveBlogEventsProps = {
  events?: LiveBlogEvent[];
};

const LiveBlogEvents = ({ events = [] }: LiveBlogEventsProps) => {
  const hasEvents = events.length > 0;

  return (
    <Box sx={styles.events}>
      <Typography variant="h2" sx={styles.title}>
        LiveBlog Events
      </Typography>

      <Box sx={styles.eventsContainer}>
        {hasEvents ? (
          events?.map((event, index) => (
            <Box key={index} sx={styles.eventItem}>
              <Typography variant="h5" sx={styles.author}>
                {event?.author}
              </Typography>

              {event?.title !== event?.author && (
                <Typography variant="h5" sx={styles.descr}>
                  {event?.title}
                </Typography>
              )}

              <Typography variant="h6" sx={styles.status}>
                {event?.status}
              </Typography>

              {event.slug && (
                <Link
                  href={`${ATHLETIKO_URL}/${event.slug}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  underline="hover"
                  variant="h5"
                  sx={styles.link}
                >
                  Δες το event <EastOutlinedIcon sx={styles.icon} />
                </Link>
              )}

              <Divider sx={styles.divider} />
            </Box>
          ))
        ) : (
          <Box sx={styles.empty}>
            <Typography variant="h5" sx={styles.emptyMessage}>
              Δεν υπάρχουν LiveBlog events αυτή τη στιγμή
            </Typography>

            <Box sx={styles.noEvents}>
              <NoEvents />
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default LiveBlogEvents;
